import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Zap, Sun } from 'lucide-react';
const steps = [{
  day: 'Viernes',
  title: 'PREPARACIÓN',
  description: "Preparas tu 'Teatro del Éxito' con nuestra lista de suministros.",
  icon: Calendar,
  color: 'bg-blue-100 text-blue-600'
}, {
  day: 'Sábado y Domingo',
  title: 'INMERSIÓN',
  description: 'Aplicas el protocolo biológico y la conexión cuerpo-cerebro.',
  icon: Zap,
  color: 'bg-coral/20 text-coral-dark'
}, {
  day: 'Lunes',
  title: 'SALIDA Y ESCUELA',
  description: 'Transición al mundo exterior y al daycare con confianza absoluta.',
  icon: Sun,
  color: 'bg-green-100 text-green-600'
}];
export function HowItWorksSection() {
  return <section className="bg-white py-14 px-4" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-71">
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-72">
            Así funciona el método
          </h2>
          <p className="text-xl text-gray-600" data-id="element-73">
            Tu plan de batalla exacto para el fin de semana.
          </p>
        </motion.div>

        <div className="relative" data-id="element-74">
          {/* Connecting Line for Desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-light-teal -translate-y-1/2 z-0" data-id="element-75"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative z-10" data-id="element-76">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-white p-6 rounded-3xl shadow-xl border border-gray-50 flex flex-col items-center text-center relative" data-id="element-77">
                <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 shadow-inner ${step.color} md:absolute md:-top-10`} data-id="element-78">
                  <step.icon size={32} data-id="element-79" />
                </div>

                <div className="md:mt-12" data-id="element-80">
                  <span className="text-sm font-bold tracking-wider uppercase text-gray-400 mb-2 block" data-id="element-81">
                    {step.day}
                  </span>
                  <h3 className="text-2xl font-black text-dark-teal mb-3" data-id="element-82">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-lg" data-id="element-83">{step.description}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}